export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-base font-bold">
                <i className="ri-book-open-line"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">香蕉漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              海量漫画免费阅读平台，免费漫画大全、免费看漫画、免费更新一应俱全，零成本畅享全本漫画。收录五万余部漫画作品，每日同步更新，数百万漫迷的共同选择。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h3>
            <div className="space-y-2">
              <a href="#hero" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a>
              <a href="#carousel" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">精选专题</a>
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门推荐</a>
              <a href="#ranking" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">人气排行</a>
              <a href="#index" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">分类索引</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">漫画分类</h3>
            <div className="space-y-2">
              <span className="block text-sm text-background-400 whitespace-nowrap cursor-pointer hover:text-primary-400 transition-colors">热血少年漫</span>
              <span className="block text-sm text-background-400 whitespace-nowrap cursor-pointer hover:text-primary-400 transition-colors">恋爱甜宠漫</span>
              <span className="block text-sm text-background-400 whitespace-nowrap cursor-pointer hover:text-primary-400 transition-colors">奇幻冒险漫</span>
              <span className="block text-sm text-background-400 whitespace-nowrap cursor-pointer hover:text-primary-400 transition-colors">悬疑推理漫</span>
              <span className="block text-sm text-background-400 whitespace-nowrap cursor-pointer hover:text-primary-400 transition-colors">国漫精选</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h3>
            <div className="space-y-2">
              <span className="block text-sm text-background-500">更多合作伙伴即将入驻</span>
            </div>
            <h3 className="text-sm font-heading font-bold text-background-50 mt-6 mb-3">关注我们</h3>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020 - 2026 香蕉漫画网. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}